const { round } = Math;

const updateXAxis = (coordinates, ratio) => {
  if (coordinates.x > 0) {
    coordinates.x = round(coordinates.x * ratio);
  }

  coordinates.width = round(coordinates.width * ratio);

  return coordinates;
};

const updateYAxis = (coordinates, ratio) => {
  if (coordinates.y > 0) {
    coordinates.y = round(coordinates.y * ratio);
  }

  coordinates.height = round(coordinates.height * ratio);

  return coordinates;
};

export default (data, updateData, dimensions) => {
  updateData = { ...updateData };

  let customCoordinates = { ...updateData.customCoordinates };

  if (data.preview && dimensions) {
    if (data.preview.width < dimensions[0]) {
      // preview width different than org image - resize occurred
      const widthRat = data.preview.width / dimensions[0];

      customCoordinates = updateXAxis(customCoordinates, widthRat);
      updateData.changed = true;
    }

    if (data.preview.height < dimensions[1]) {
      // preview height different than org image - resize occurred
      const heightRat = data.preview.height / dimensions[1];

      customCoordinates = updateYAxis(customCoordinates, heightRat);
      updateData.changed = true;
    }

    updateData.customCoordinates = customCoordinates;
  }

  return {
    ...updateData,
    customCoordinates,
  };
};
